import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface LocaleState {
  // The set of selected locale codes across all permitted locations, e.g.
  // ["en-us", "en-ca", "de-de"]. North America keeps all of its locales
  // auto-selected; other locations keep one active, switchable locale.
  selectedLocales: string[];
}

const initialState: LocaleState = {
  selectedLocales: [],
};

export const localeSlice = createSlice({
  name: 'locale',
  initialState,
  reducers: {
    // Switches the active locale for a location, replacing any other locale
    // previously selected under the same location (one active per location).
    // The location always keeps one active locale: re-selecting the active
    // locale is a no-op (no empty/deselect state).
    selectLocationLocale(state, action: PayloadAction<{ locale: string; locationLocales: string[] }>) {
      const { locale, locationLocales } = action.payload;
      const withoutLocation = state.selectedLocales.filter((value) => !locationLocales.includes(value));
      state.selectedLocales = [...withoutLocation, locale];
    },
    // Seeds the default selection only when nothing has been selected yet so
    // user switches are preserved across re-renders.
    setDefaultLocales(state, action: PayloadAction<string[]>) {
      if (state.selectedLocales.length === 0) {
        state.selectedLocales = action.payload;
      }
    },
  },
});

export const { selectLocationLocale, setDefaultLocales } = localeSlice.actions;
export default localeSlice.reducer;
